import regions from './regions';
class RegionsUtil {
    /**
     * 获取级联的options集合
     */
    getRegionsOptions() {
        let arr1 = this.getProvinces();
        let arr2 = this.getCitys(arr1);
        return arr2;
    }
    getProvinces() {
        let arr = [];
        regions.map(item => {
            let { id, name, parent_id } = item;
            let obj = { value: 0, label: '' };
            if (parent_id == 0) {
                obj.value = id;
                obj.label = name;
                arr.push(obj);
            }
        });
        return arr;
    }
    getCitys(arr) {
        arr.map((province) => {
            let childArr = [];
            regions.map(city => {
                let obj = {};
                if (province.value == city.parent_id) {
                    obj.value = city.id;
                    obj.label = city.name;
                    obj.children = this.getArea(obj);
                    childArr.push(obj);
                }
            });
            province.children = childArr;
            this.getArea(childArr);
        });
        return arr;
    }
    /**
 * arr 某省城市的地区集合
 */
    getArea(city) {
        let childArr = [];
        regions.map(area => {
            if (area.parent_id == city.value) {
                let obj = {};
                if (area.parent_id == city.value) {
                    obj.value = area.id;
                    obj.label = area.name;
                }
                childArr.push(obj);
            }
        });
        return childArr;
    }
}
export default new RegionsUtil();
